import { IconTypes } from '@eika/icon';
const damageInsuranceProducts = {
    // PERSONAL
    N16: {
        name: 'Helseforsikring',
        icon: IconTypes.HELSE_36,
        url: 'helseforsikring',
    },
    N17: {
        name: 'Personalforsikring',
        icon: IconTypes.PERSONER_36,
        url: 'personalforsikring',
    },
    N75: {
        name: 'Virke Yrkesskadeforsikring – Fritidsulykkesforsikring ved tilvalg',
        icon: IconTypes.PLASTER_36,
        url: 'virke-yrkesskade',
    },
    N76: {
        name: 'Virke Personalforsikring',
        icon: IconTypes.PERSONER_36,
        url: 'virke-personalforsikring-navnebasert',
    },
    N77: {
        name: 'Virke Personalforsikring',
        icon: IconTypes.PERSONER_36,
        url: 'virke-personal_selvadministrert',
    },
    N20: {
        name: 'Yrkesskade',
        icon: IconTypes.PLASTER_36,
        url: 'yrkesskade',
    },
    N80: {
        name: 'Kollektiv ulykke',
        icon: IconTypes.ULYKKE_36,
        url: 'kollektivulykke',
    },
    N85: {
        name: 'Reise bedrift',
        icon: IconTypes.FORSIKRINGSBEVIS_REISE_36,
        url: 'reisebedrift',
    },
    N90: {
        name: 'Reise, korttid',
        icon: IconTypes.FORSIKRINGSBEVIS_REISE_36,
        url: 'reisekorttid',
    },
    P10: {
        name: 'Reiseforsikring',
        icon: IconTypes.FORSIKRINGSBEVIS_REISE_36,
        url: 'reise',
        useRicherDetailsUrl: true,
    },
    P11: {
        name: 'Utvidet reisetid',
        icon: IconTypes.FORSIKRINGSBEVIS_REISE_36,
        url: 'utvidetreisetid',
    },
    P15: {
        name: 'Ulykke',
        icon: IconTypes.ULYKKE_36,
        url: 'ulykke',
    },
    P16: {
        name: 'Helseforsikring',
        icon: IconTypes.HELSE_36,
        url: 'helseforsikring',
    },
    P40: {
        name: 'Student i utlandet',
        icon: IconTypes.UNG_36,
        url: 'studentiutlandet',
    },
    P45: {
        name: 'UNG i Norge',
        icon: IconTypes.UNG_36,
        url: 'ung',
        useRicherDetailsUrl: true,
    },
    P46: {
        name: 'UNG Familie',
        icon: IconTypes.FAMILIE_36,
        url: 'ungfamilie',
    },
    P50: {
        name: 'Eika Kort',
        icon: IconTypes.PARAPLY_36,
        url: 'eikakort',
    },
    P60: {
        name: 'Inntektsforsikring',
        icon: IconTypes.INNTEKT_36,
        url: 'inntekt',
    },
    L55: {
        name: 'Bondens ulykke',
        icon: IconTypes.ULYKKE_36,
        url: 'bondensulykke',
    },
    // VEHICLE
    N31: {
        name: 'Drosje',
        icon: IconTypes.TAXI_36,
        url: 'drosje',
    },
    N33: {
        name: 'Næringsbil',
        icon: IconTypes.HANDTVERKER__BIL_36,
        url: 'naringsbil',
    },
    N35: {
        name: 'Storbil',
        icon: IconTypes.LASTEBIL_36,
        url: 'storbil',
    },
    N40: {
        name: 'Tilhenger/tralle',
        icon: IconTypes.TILHENGER_36,
        url: 'tilhengertralle',
    },
    L21: {
        name: 'Landbruks- og arbeidsmaskin',
        icon: IconTypes.TRAKTOR_36,
        url: 'landbruksogarbeidsmaskin',
    },
    L20: {
        name: 'Landbruksmaskin',
        icon: IconTypes.GRAVEMASKIN_36,
        url: 'landbruksmaskin',
    },
    M05: {
        name: 'Bilforsikring',
        icon: IconTypes.BIL_36,
        url: 'bil',
        useRicherDetailsUrl: true,
    },
    M10: {
        name: 'Tilhenger eller campingvogn',
        icon: IconTypes.CAMPING_36,
        url: 'tilhenger',
    },
    M15: {
        name: 'Moped',
        icon: IconTypes.MOPED_36,
        url: 'moped',
    },
    M20: {
        name: 'Veterankjøretøy',
        icon: IconTypes.VETERANBIL_36,
        url: 'veterankjoretoy',
    },
    M25: {
        name: 'Motorsykkel',
        icon: IconTypes.MOTORSYKKEL_36,
        url: 'motorsykkel',
    },
    M26: {
        name: 'Motorsykkel',
        icon: IconTypes.MOTORSYKKEL_36,
        url: 'motorsykkel-ny',
    },
    M30: {
        name: 'Snøscooter',
        icon: IconTypes.SNOSCOOTER_36,
        url: 'snoscooter',
    },
    M35: {
        name: 'Bobil',
        icon: IconTypes.BOBIL_36,
        url: 'bobil',
    },
    M37: {
        name: 'ATV',
        icon: IconTypes.ATV_36,
        url: 'atv',
    },
    M40: {
        name: 'Russebil',
        icon: IconTypes.KJORETOY_36,
        url: 'russebil',
    },
    M45: {
        name: 'Privat traktor',
        icon: IconTypes.TRAKTOR_36,
        url: 'traktor',
    },
    // TRANSPORT
    N55: {
        name: 'Transport egen bil',
        url: 'transportegenbil',
        icon: IconTypes.VARETRANSPORT_36,
    },
    N56: {
        name: 'Transport bedrift',
        icon: IconTypes.VARETRANSPORT_36,
        url: 'transportbedrift',
    },
    N57: {
        name: 'Transport engangs',
        icon: IconTypes.VARETRANSPORT_36,
        url: 'transportengangs',
    },
    // BUILDING/OPERATION
    N05: {
        name: 'Bedrift',
        icon: IconTypes.BEDRIFT_36,
        url: 'bedrift',
    },
    N06: {
        name: 'Håndverker',
        icon: IconTypes.HANDVERKER_36,
        url: 'handverker',
    },
    N07: {
        name: 'Næringsforsikring',
        icon: IconTypes.HANDTRYKK_36,
        url: 'naeringsforsikring',
    },
    N10: {
        name: 'Butikk',
        icon: IconTypes.BUTIKK_36,
        url: 'butikk',
    },
    N15: {
        name: 'Kontor',
        icon: IconTypes.KONTOR_36,
        url: 'kontor',
    },
    N18: {
        name: 'Helseforsikring Bedrift',
        icon: IconTypes.LEGE_36,
        url: 'helseforsikring-bedrift',
    },
    N22: {
        name: 'Bolig til utleie',
        icon: IconTypes.HUS_36,
        url: 'boligtilutleie',
    },
    N25: {
        name: 'Huseier',
        icon: IconTypes.HUS_36,
        url: 'huseier',
    },
    N30: {
        name: 'Huseier bedrift',
        icon: IconTypes.HUS_36,
        url: 'huseier-bedrift',
    },
    N45: {
        name: 'Arbeidsmaskin',
        icon: IconTypes.GRAVEMASKIN_36,
        url: 'arbeidsmaskin',
    },
    N50: {
        name: 'Ansvar',
        icon: IconTypes.GRUPPE_36,
        url: 'ansvar',
    },
    N53: {
        name: 'Dataangrepsforsikring',
        icon: IconTypes.SIKKERHET_36,
        url: 'cyber',
    },
    N60: {
        name: 'Maskin',
        icon: IconTypes.GRAVEMASKIN_36,
        url: 'maskin',
    },
    N70: {
        name: 'Bankdrift',
        icon: IconTypes.BANK_36,
        url: 'bankdrift',
    },
    N95: {
        name: 'Formueskade',
        icon: IconTypes.PENGESEKK_36,
        url: 'formueskade',
    },
    L05: {
        name: 'Landbruk bolighus',
        icon: IconTypes.BONDEGARD_36,
        url: 'landbrukbolighus',
    },
    L10: {
        name: 'Landbruk driftsbygning',
        icon: IconTypes.BEDRIFT_36,
        url: 'landbrukdriftsbygning',
    },
    L15: {
        name: 'Landbruk løsøre/avl./besetn',
        icon: IconTypes.TILHENGER_36,
        url: 'landbruklosoreavlbesetn',
    },
    L17: {
        name: 'Driftsb./løsøre nedlagt bruk',
        icon: IconTypes.TILHENGER_36,
        url: 'driftsblosorenedlagtbruk',
    },
    P05: {
        name: 'Boligforsikring',
        icon: IconTypes.HUS_36,
        url: 'bolig',
        useRicherDetailsUrl: true,
    },
    P07: {
        name: 'Innboforsikring',
        icon: IconTypes.INNBOFORSIKRING_36,
        url: 'innbo',
        useRicherDetailsUrl: true,
    },
    P08: {
        name: 'Innboforsikring',
        icon: IconTypes.INNBOFORSIKRING_36,
        url: 'innbobos',
    },
    P20: {
        name: 'Hytteforsikring',
        icon: IconTypes.HYTTE_36,
        url: 'fritidsbolig',
        useRicherDetailsUrl: true,
    },
    P44: {
        name: 'Eika Pluss',
        icon: IconTypes.PARAPLY_36,
        url: 'eikapluss',
    },
    // PRIVATE
    P25: {
        name: 'Verdigjenstand',
        icon: IconTypes.VERDI_36,
        url: 'verdigjenstand',
    },
    P29: {
        name: 'Hund',
        icon: IconTypes.HUND_36,
        url: 'hund',
        useRicherDetailsUrl: true,
    },
    P30: {
        name: 'Hund/katt',
        icon: IconTypes.KATT_36,
        url: 'hundkatt',
    },
    P35: {
        name: 'Fritidsbåt',
        icon: IconTypes.BAT_36,
        url: 'fritidsbat',
    },
    P53: {
        name: 'Onlineforsikring',
        icon: IconTypes.MOBIL_36,
        url: 'onlineforsikring',
    },
    // AGRICULTURE
    L25: {
        name: 'Hest',
        icon: IconTypes.HEST_36,
        url: 'hest',
    },
    L30: {
        name: 'Landbruk yrkesskade',
        icon: IconTypes.PLASTER_36,
        url: 'landbrukyrkesskade',
    },
    L35: {
        name: 'Landbruk gårdsbil',
        icon: IconTypes.BIL_36,
        url: 'landbrukgardsbil',
    },
    L40: {
        name: 'Husdyr',
        icon: IconTypes.KU_36,
        url: 'husdyr',
    },
    L45: {
        name: 'Fjørfe',
        icon: IconTypes.HONE_36,
        url: 'fjorfe',
    },
    L50: {
        name: 'Husdyr individuell',
        icon: IconTypes.KU_36,
        url: 'husdyrindividuell',
    },
    N04: {
        name: 'Eiendeler',
        icon: IconTypes.PARAPLY_36,
        url: 'eiendeler',
    },
    M16: {
        name: 'Elsparkesykkel',
        icon: IconTypes.ELSPAREKSYKKEL_36,
        url: 'elsparkesykkel',
        useRicherDetailsUrl: true,
    },
    N49: {
        name: 'Elsparkesykkel utleie',
        icon: IconTypes.ELSPAREKSYKKEL_36,
        url: 'sma-elkjoretoy-utleie',
    },
    P71: {
        name: 'Drone',
        icon: IconTypes.DRONE_36,
        url: 'drone',
    },
    N51: {
        name: 'Miljø',
        icon: IconTypes.JORDEN_36,
        url: 'miljo',
    },
};
export default damageInsuranceProducts;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGFtYWdlSW5zdXJhbmNlUHJvZHVjdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvdXRpbHMvaW5zdXJhbmNlL2RhbWFnZUluc3VyYW5jZVByb2R1Y3RzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxZQUFZLENBQUM7QUFLdkMsTUFBTSx1QkFBdUIsR0FBeUQ7SUFDbEYsV0FBVztJQUNYLEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxpQkFBaUI7UUFDdkIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxRQUFRO1FBQ3hCLEdBQUcsRUFBRSxpQkFBaUI7S0FDekI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsb0JBQW9CO1FBQzFCLElBQUksRUFBRSxTQUFTLENBQUMsV0FBVztRQUMzQixHQUFHLEVBQUUsb0JBQW9CO0tBQzVCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLG1FQUFtRTtRQUN6RSxJQUFJLEVBQUUsU0FBUyxDQUFDLFVBQVU7UUFDMUIsR0FBRyxFQUFFLGtCQUFrQjtLQUMxQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSwwQkFBMEI7UUFDaEMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxXQUFXO1FBQzNCLEdBQUcsRUFBRSxzQ0FBc0M7S0FDOUM7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsMEJBQTBCO1FBQ2hDLElBQUksRUFBRSxTQUFTLENBQUMsV0FBVztRQUMzQixHQUFHLEVBQUUsaUNBQWlDO0tBQ3pDO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLFlBQVk7UUFDbEIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxVQUFVO1FBQzFCLEdBQUcsRUFBRSxZQUFZO0tBQ3BCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLGtCQUFrQjtRQUN4QixJQUFJLEVBQUUsU0FBUyxDQUFDLFNBQVM7UUFDekIsR0FBRyxFQUFFLGlCQUFpQjtLQUN6QjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxlQUFlO1FBQ3JCLElBQUksRUFBRSxTQUFTLENBQUMseUJBQXlCO1FBQ3pDLEdBQUcsRUFBRSxjQUFjO0tBQ3RCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLGdCQUFnQjtRQUN0QixJQUFJLEVBQUUsU0FBUyxDQUFDLHlCQUF5QjtRQUN6QyxHQUFHLEVBQUUsY0FBYztLQUN0QjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxpQkFBaUI7UUFDdkIsSUFBSSxFQUFFLFNBQVMsQ0FBQyx5QkFBeUI7UUFDekMsR0FBRyxFQUFFLE9BQU87UUFDWixtQkFBbUIsRUFBRSxJQUFJO0tBQzVCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLGtCQUFrQjtRQUN4QixJQUFJLEVBQUUsU0FBUyxDQUFDLHlCQUF5QjtRQUN6QyxHQUFHLEVBQUUsaUJBQWlCO0tBQ3pCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLFFBQVE7UUFDZCxJQUFJLEVBQUUsU0FBUyxDQUFDLFNBQVM7UUFDekIsR0FBRyxFQUFFLFFBQVE7S0FDaEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsaUJBQWlCO1FBQ3ZCLElBQUksRUFBRSxTQUFTLENBQUMsUUFBUTtRQUN4QixHQUFHLEVBQUUsaUJBQWlCO0tBQ3pCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLG9CQUFvQjtRQUMxQixJQUFJLEVBQUUsU0FBUyxDQUFDLE1BQU07UUFDdEIsR0FBRyxFQUFFLGtCQUFrQjtLQUMxQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxhQUFhO1FBQ25CLElBQUksRUFBRSxTQUFTLENBQUMsTUFBTTtRQUN0QixHQUFHLEVBQUUsS0FBSztRQUNWLG1CQUFtQixFQUFFLElBQUk7S0FDNUI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsYUFBYTtRQUNuQixJQUFJLEVBQUUsU0FBUyxDQUFDLFVBQVU7UUFDMUIsR0FBRyxFQUFFLFlBQVk7S0FDcEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsV0FBVztRQUNqQixJQUFJLEVBQUUsU0FBUyxDQUFDLFVBQVU7UUFDMUIsR0FBRyxFQUFFLFVBQVU7S0FDbEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsb0JBQW9CO1FBQzFCLElBQUksRUFBRSxTQUFTLENBQUMsVUFBVTtRQUMxQixHQUFHLEVBQUUsU0FBUztLQUNqQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxnQkFBZ0I7UUFDdEIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxTQUFTO1FBQ3pCLEdBQUcsRUFBRSxlQUFlO0tBQ3ZCO0lBQ0QsVUFBVTtJQUNWLEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxRQUFRO1FBQ2QsSUFBSSxFQUFFLFNBQVMsQ0FBQyxPQUFPO1FBQ3ZCLEdBQUcsRUFBRSxRQUFRO0tBQ2hCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLFlBQVk7UUFDbEIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxtQkFBbUI7UUFDbkMsR0FBRyxFQUFFLFlBQVk7S0FDcEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsU0FBUztRQUNmLElBQUksRUFBRSxTQUFTLENBQUMsV0FBVztRQUMzQixHQUFHLEVBQUUsU0FBUztLQUNqQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxrQkFBa0I7UUFDeEIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxZQUFZO1FBQzVCLEdBQUcsRUFBRSxpQkFBaUI7S0FDekI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsNkJBQTZCO1FBQ25DLElBQUksRUFBRSxTQUFTLENBQUMsVUFBVTtRQUMxQixHQUFHLEVBQUUsMEJBQTBCO0tBQ2xDO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLGlCQUFpQjtRQUN2QixJQUFJLEVBQUUsU0FBUyxDQUFDLGNBQWM7UUFDOUIsR0FBRyxFQUFFLGlCQUFpQjtLQUN6QjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxlQUFlO1FBQ3JCLElBQUksRUFBRSxTQUFTLENBQUMsTUFBTTtRQUN0QixHQUFHLEVBQUUsS0FBSztRQUNWLG1CQUFtQixFQUFFLElBQUk7S0FDNUI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsNkJBQTZCO1FBQ25DLElBQUksRUFBRSxTQUFTLENBQUMsVUFBVTtRQUMxQixHQUFHLEVBQUUsV0FBVztLQUNuQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxPQUFPO1FBQ2IsSUFBSSxFQUFFLFNBQVMsQ0FBQyxRQUFRO1FBQ3hCLEdBQUcsRUFBRSxPQUFPO0tBQ2Y7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsaUJBQWlCO1FBQ3ZCLElBQUksRUFBRSxTQUFTLENBQUMsYUFBYTtRQUM3QixHQUFHLEVBQUUsaUJBQWlCO0tBQ3pCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLGFBQWE7UUFDbkIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxjQUFjO1FBQzlCLEdBQUcsRUFBRSxhQUFhO0tBQ3JCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLGFBQWE7UUFDbkIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxjQUFjO1FBQzlCLEdBQUcsRUFBRSxnQkFBZ0I7S0FDeEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsWUFBWTtRQUNsQixJQUFJLEVBQUUsU0FBUyxDQUFDLGFBQWE7UUFDN0IsR0FBRyxFQUFFLFlBQVk7S0FDcEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsT0FBTztRQUNiLElBQUksRUFBRSxTQUFTLENBQUMsUUFBUTtRQUN4QixHQUFHLEVBQUUsT0FBTztLQUNmO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLEtBQUs7UUFDWCxJQUFJLEVBQUUsU0FBUyxDQUFDLE1BQU07UUFDdEIsR0FBRyxFQUFFLEtBQUs7S0FDYjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxVQUFVO1FBQ2hCLElBQUksRUFBRSxTQUFTLENBQUMsV0FBVztRQUMzQixHQUFHLEVBQUUsVUFBVTtLQUNsQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxnQkFBZ0I7UUFDdEIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxVQUFVO1FBQzFCLEdBQUcsRUFBRSxTQUFTO0tBQ2pCO0lBQ0QsWUFBWTtJQUNaLEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxvQkFBb0I7UUFDMUIsR0FBRyxFQUFFLGtCQUFrQjtRQUN2QixJQUFJLEVBQUUsU0FBUyxDQUFDLGdCQUFnQjtLQUNuQztJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxtQkFBbUI7UUFDekIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxnQkFBZ0I7UUFDaEMsR0FBRyxFQUFFLGtCQUFrQjtLQUMxQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxtQkFBbUI7UUFDekIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxnQkFBZ0I7UUFDaEMsR0FBRyxFQUFFLGtCQUFrQjtLQUMxQjtJQUNELHFCQUFxQjtJQUNyQixHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsU0FBUztRQUNmLElBQUksRUFBRSxTQUFTLENBQUMsVUFBVTtRQUMxQixHQUFHLEVBQUUsU0FBUztLQUNqQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxZQUFZO1FBQ2xCLElBQUksRUFBRSxTQUFTLENBQUMsYUFBYTtRQUM3QixHQUFHLEVBQUUsWUFBWTtLQUNwQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxtQkFBbUI7UUFDekIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxZQUFZO1FBQzVCLEdBQUcsRUFBRSxvQkFBb0I7S0FDNUI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsUUFBUTtRQUNkLElBQUksRUFBRSxTQUFTLENBQUMsU0FBUztRQUN6QixHQUFHLEVBQUUsUUFBUTtLQUNoQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxRQUFRO1FBQ2QsSUFBSSxFQUFFLFNBQVMsQ0FBQyxTQUFTO1FBQ3pCLEdBQUcsRUFBRSxRQUFRO0tBQ2hCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLHlCQUF5QjtRQUMvQixJQUFJLEVBQUUsU0FBUyxDQUFDLE9BQU87UUFDdkIsR0FBRyxFQUFFLHlCQUF5QjtLQUNqQztJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxrQkFBa0I7UUFDeEIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFNO1FBQ3RCLEdBQUcsRUFBRSxnQkFBZ0I7S0FDeEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsU0FBUztRQUNmLElBQUksRUFBRSxTQUFTLENBQUMsTUFBTTtRQUN0QixHQUFHLEVBQUUsU0FBUztLQUNqQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxpQkFBaUI7UUFDdkIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFNO1FBQ3RCLEdBQUcsRUFBRSxpQkFBaUI7S0FDekI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsZUFBZTtRQUNyQixJQUFJLEVBQUUsU0FBUyxDQUFDLGNBQWM7UUFDOUIsR0FBRyxFQUFFLGVBQWU7S0FDdkI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsUUFBUTtRQUNkLElBQUksRUFBRSxTQUFTLENBQUMsU0FBUztRQUN6QixHQUFHLEVBQUUsUUFBUTtLQUNoQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSx1QkFBdUI7UUFDN0IsSUFBSSxFQUFFLFNBQVMsQ0FBQyxZQUFZO1FBQzVCLEdBQUcsRUFBRSxPQUFPO0tBQ2Y7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsUUFBUTtRQUNkLElBQUksRUFBRSxTQUFTLENBQUMsY0FBYztRQUM5QixHQUFHLEVBQUUsUUFBUTtLQUNoQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxXQUFXO1FBQ2pCLElBQUksRUFBRSxTQUFTLENBQUMsT0FBTztRQUN2QixHQUFHLEVBQUUsV0FBVztLQUNuQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxhQUFhO1FBQ25CLElBQUksRUFBRSxTQUFTLENBQUMsWUFBWTtRQUM1QixHQUFHLEVBQUUsYUFBYTtLQUNyQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxtQkFBbUI7UUFDekIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxZQUFZO1FBQzVCLEdBQUcsRUFBRSxrQkFBa0I7S0FDMUI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsd0JBQXdCO1FBQzlCLElBQUksRUFBRSxTQUFTLENBQUMsVUFBVTtRQUMxQixHQUFHLEVBQUUsdUJBQXVCO0tBQy9CO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLDZCQUE2QjtRQUNuQyxJQUFJLEVBQUUsU0FBUyxDQUFDLFlBQVk7UUFDNUIsR0FBRyxFQUFFLHlCQUF5QjtLQUNqQztJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSw4QkFBOEI7UUFDcEMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxZQUFZO1FBQzVCLEdBQUcsRUFBRSwwQkFBMEI7S0FDbEM7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsaUJBQWlCO1FBQ3ZCLElBQUksRUFBRSxTQUFTLENBQUMsTUFBTTtRQUN0QixHQUFHLEVBQUUsT0FBTztRQUNaLG1CQUFtQixFQUFFLElBQUk7S0FDNUI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsaUJBQWlCO1FBQ3ZCLElBQUksRUFBRSxTQUFTLENBQUMsa0JBQWtCO1FBQ2xDLEdBQUcsRUFBRSxPQUFPO1FBQ1osbUJBQW1CLEVBQUUsSUFBSTtLQUM1QjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxpQkFBaUI7UUFDdkIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxrQkFBa0I7UUFDbEMsR0FBRyxFQUFFLFVBQVU7S0FDbEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsaUJBQWlCO1FBQ3ZCLElBQUksRUFBRSxTQUFTLENBQUMsUUFBUTtRQUN4QixHQUFHLEVBQUUsY0FBYztRQUNuQixtQkFBbUIsRUFBRSxJQUFJO0tBQzVCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLFlBQVk7UUFDbEIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxVQUFVO1FBQzFCLEdBQUcsRUFBRSxXQUFXO0tBQ25CO0lBQ0QsVUFBVTtJQUNWLEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxnQkFBZ0I7UUFDdEIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxRQUFRO1FBQ3hCLEdBQUcsRUFBRSxnQkFBZ0I7S0FDeEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsTUFBTTtRQUNaLElBQUksRUFBRSxTQUFTLENBQUMsT0FBTztRQUN2QixHQUFHLEVBQUUsTUFBTTtRQUNYLG1CQUFtQixFQUFFLElBQUk7S0FDNUI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsV0FBVztRQUNqQixJQUFJLEVBQUUsU0FBUyxDQUFDLE9BQU87UUFDdkIsR0FBRyxFQUFFLFVBQVU7S0FDbEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsWUFBWTtRQUNsQixJQUFJLEVBQUUsU0FBUyxDQUFDLE1BQU07UUFDdEIsR0FBRyxFQUFFLFlBQVk7S0FDcEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsa0JBQWtCO1FBQ3hCLElBQUksRUFBRSxTQUFTLENBQUMsUUFBUTtRQUN4QixHQUFHLEVBQUUsa0JBQWtCO0tBQzFCO0lBQ0QsY0FBYztJQUNkLEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxNQUFNO1FBQ1osSUFBSSxFQUFFLFNBQVMsQ0FBQyxPQUFPO1FBQ3ZCLEdBQUcsRUFBRSxNQUFNO0tBQ2Q7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUscUJBQXFCO1FBQzNCLElBQUksRUFBRSxTQUFTLENBQUMsVUFBVTtRQUMxQixHQUFHLEVBQUUsb0JBQW9CO0tBQzVCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLG1CQUFtQjtRQUN6QixJQUFJLEVBQUUsU0FBUyxDQUFDLE1BQU07UUFDdEIsR0FBRyxFQUFFLGtCQUFrQjtLQUMxQjtJQUNELEdBQUcsRUFBRTtRQUNELElBQUksRUFBRSxRQUFRO1FBQ2QsSUFBSSxFQUFFLFNBQVMsQ0FBQyxLQUFLO1FBQ3JCLEdBQUcsRUFBRSxRQUFRO0tBQ2hCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLFFBQVE7UUFDZCxJQUFJLEVBQUUsU0FBUyxDQUFDLE9BQU87UUFDdkIsR0FBRyxFQUFFLFFBQVE7S0FDaEI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsb0JBQW9CO1FBQzFCLElBQUksRUFBRSxTQUFTLENBQUMsS0FBSztRQUNyQixHQUFHLEVBQUUsbUJBQW1CO0tBQzNCO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLFdBQVc7UUFDakIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxVQUFVO1FBQzFCLEdBQUcsRUFBRSxXQUFXO0tBQ25CO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLGdCQUFnQjtRQUN0QixJQUFJLEVBQUUsU0FBUyxDQUFDLGlCQUFpQjtRQUNqQyxHQUFHLEVBQUUsZ0JBQWdCO1FBQ3JCLG1CQUFtQixFQUFFLElBQUk7S0FDNUI7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsdUJBQXVCO1FBQzdCLElBQUksRUFBRSxTQUFTLENBQUMsaUJBQWlCO1FBQ2pDLEdBQUcsRUFBRSx1QkFBdUI7S0FDL0I7SUFDRCxHQUFHLEVBQUU7UUFDRCxJQUFJLEVBQUUsT0FBTztRQUNiLElBQUksRUFBRSxTQUFTLENBQUMsUUFBUTtRQUN4QixHQUFHLEVBQUUsT0FBTztLQUNmO0lBQ0QsR0FBRyxFQUFFO1FBQ0QsSUFBSSxFQUFFLE9BQU87UUFDYixJQUFJLEVBQUUsU0FBUyxDQUFDLFNBQVM7UUFDekIsR0FBRyxFQUFFLE9BQU87S0FDZjtDQUNKLENBQUM7QUFFRixlQUFlLHVCQUF1QixDQUFDIn0=